import {
  TCountry,
  TEntity,
  TLanguage,
  TPrivacyCenterContent,
  TUserType,
} from 'contexts/app-context/types'

interface HomePrefetchSession {
  privacyCenterContent?: TPrivacyCenterContent
  userCountry?: TCountry
  userSelectedEntity?: TEntity
  userAccountType?: TUserType
  userLanguage?: TLanguage
}

type ReadyHomePrefetchSession = Required<HomePrefetchSession>

const isHomePrefetchReady = (
  isAppLoading: boolean,
  session: HomePrefetchSession,
): session is ReadyHomePrefetchSession => {
  if (isAppLoading) return false

  const { privacyCenterContent, userCountry, userSelectedEntity, userAccountType, userLanguage } =
    session

  if (!privacyCenterContent || !userCountry || !userSelectedEntity) return false

  return Boolean(userAccountType && userLanguage)
}

export type { HomePrefetchSession, ReadyHomePrefetchSession }
export { isHomePrefetchReady }
